import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const CustomSelectFilter = props => {
  const { column, onFilter, paramFilter, dataSelect, placeholder } = props;
  const { t, i18n } = useTranslation();

  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (paramFilter) {
      const dataField = column.dataField;
      for (const key in paramFilter) {
        if (key.indexOf(dataField) !== -1) {
          const selected = dataSelect.find(x => x.value === paramFilter[key]);
          if (selected) {
            setSelectedOption(selected);
          }
        }
      }
    }
  }, [column, dataSelect, paramFilter]);

  return (
    <React.Fragment>
      <div style={{ minWidth: "200px", fontWeight: "normal" }}>
        <Select
          isClearable
          placeholder={placeholder || t("common:placeholder.select")}
          options={dataSelect}
          classNamePrefix="select2-selection"
          value={selectedOption || undefined}
          onChange={data => {
            onFilter({ data: data });
          }}
        />
      </div>
    </React.Fragment>
  );
};

CustomSelectFilter.propTypes = {
  column: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
  paramFilter: PropTypes.any.isRequired,
  dataSelect: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
};

CustomSelectFilter.defaultProps = {
  dataSelect: [],
  placeholder: "",
};

export default CustomSelectFilter;
